<div class="game-event" [style.border-left]="'5px solid ' + Event.EventColor">
    <div (click)="openGameDetails()" style="cursor: pointer;">      
      {{Event.EventStartUTC+'Z' | date: 'HH:mm'}} {{Event.DivisionName}}<br>
      {{Event.HomeTeamName}} - {{Event.AwayTeamName}}<br>
      <span style="color: gray">{{Event.LastName}}, {{Event.FirstName}}</span>
    </div>
  </div> 

